import { H5 } from "@sellar-io/components";
import { ProfilePicture } from "../../../../components";

export const SupplierNameSection = ({
  supplierLogo,
  supplierName,
}: {
  supplierLogo: string;
  supplierName: string;
}) => {
  return (
    <div className="flex max-w-[200px]">
      <ProfilePicture
        size={"small"}
        logoUrl={supplierLogo}
        name={supplierName}
        className="mr-2 rounded-full border-2 border-white bg-white"
        fallback="supplier-badge"
      />
      <div className={"flex flex-col overflow-hidden"}>
        <H5 className="truncate">{supplierName}</H5>
      </div>
    </div>
  );
};
